import { Lock, User } from 'education-icons';
import { Spin, TableCell, Text } from 'platform-components';
import React from 'react';

import { getStudentPasswordFromLocalStorageWithExpireTime } from 'common.components/students/utils';
import { Student } from 'common.components/typings';

import './students__student-passport-data-table-cell.scss';

interface Props {
    isDataLoading?: boolean;
    student: Student;
    hasYandexAccount?: boolean;
    username?: string;
}

// eslint-disable-next-line complexity
export const StudentPassportDataTableCell = (props: Props) => {
    const { isDataLoading, student } = props;

    const { username, no_yandex_account: noYandexAccount } = student;

    if (isDataLoading) {
        return (
            <TableCell mix="students__table-passport-login-password">
                <Spin center />
            </TableCell>
        );
    }

    const checkedUsername = !noYandexAccount && username ? username.toLocaleUpperCase() : '******';
    const password = getStudentPasswordFromLocalStorageWithExpireTime(student.id);
    const checkedPassword = password ? password : '******';

    return (
        <TableCell mix="students__table-passport-login-password">
            <div className="students__table-passport-login-password-data">
                <div className="students__table-passport-login">
                    <div className="students__table-passport-login-icon-container">
                        <User className="students__table-passport-login-icon" />
                    </div>
                    <Text>{checkedUsername}</Text>
                </div>
                <div className="students__table-passport-password">
                    <Lock className="students__table-passport-password-icon" />
                    <Text>{checkedPassword}</Text>
                </div>
            </div>
        </TableCell>
    );
};
